/**
 * Turns a login rejection into human copy.
 *
 * Rejections arrive two ways: `POST /users/validate` answers `valid: false`
 * with a short `reason` code, and Firebase Auth throws `auth/user-disabled`
 * for an account an admin removed. Both used to render verbatim ("user_disabled",
 * "Firebase: Error (auth/user-disabled).").
 */

export const ACCOUNT_REMOVED_MESSAGE =
  'Your account has been removed. Please contact your administrator.';

const DEFAULT_REJECTION_MESSAGE = 'Email not authorized. Please contact your administrator.';

export function validationRejectionMessage(
  reason: string | null | undefined,
  fallback: string = DEFAULT_REJECTION_MESSAGE
): string {
  if (reason === 'user_disabled') return ACCOUNT_REMOVED_MESSAGE;
  return fallback;
}

export function isFirebaseUserDisabled(error: { code?: string } | null | undefined): boolean {
  return error?.code === 'auth/user-disabled';
}
